// Who may act: operators with MFA. Everyone else sees controls greyed, with the reason.
import { useSession } from '../store/sessionStore';

export function useActGate(): { allowed: boolean; why?: string } {
  const me = useSession((s) => s.me);
  if (!me) return { allowed: false, why: 'Checking who you are…' };
  if (me.role !== 'operator') return { allowed: false, why: 'Viewers can look but not act. Ask Andrew to add you as an operator.' };
  if (!me.mfa) return { allowed: false, why: 'Enrol two-factor on your Clerk account (accounts.projectorstudio.io → Security) to act.' };
  return { allowed: true };
}
